<h5 *ngIf="showHelp" class="question-help">
  {{ 'common_select_one_of_answers' | translate }}
</h5>

<form *ngIf="form"
      [formGroup]="form"
>
</form>
